/** Looks to start from, and looks of one's own: saving, renaming, removing, and what failed. */
export const looks = {
  presets: { fieldia: 'Fieldia', calm: 'Calm', compact: 'Compact', rounded: 'Rounded', night: 'Night' } as Record<string, string>,
  /** What a tile shows in the look's font. */
  sample: 'Aa',
  needsName: 'A look needs a name',
  tooLong: (most: number) => `A name is ${most} characters at most`,
  taken: (name: string) => `There is a look named “${name}” already`,
  yourLooks: 'Your looks',
  saveThisLook: 'Save this look…',
  cancel: 'Cancel',
  undo: 'Undo',
  tryAgain: 'Try again',
  lookPresets: 'Look presets',
  startFrom: 'Start from',
  presetsHint: 'Sets the accent, font, spacing, corners and colours at once. Each stays yours to change, and a look of your own can be saved to use again.',
  /** What failed, in the store's words, or plainly when it gave none. */
  failed: (what: string, reason: string) => (reason ? `${what}: ${reason}` : `${what}. Try again in a moment.`),
  renameOrRemoveNamed: (name: string) => `Rename or remove “${name}”`,
  renameOrRemove: 'Rename or remove',
  rename: 'Rename…',
  remove: 'Remove',
  newNameFor: (name: string) => `New name for “${name}”`,
  nameThisLook: 'Name this look',
  renameButton: 'Rename',
  save: 'Save',
  couldNotRename: (name: string) => `Could not rename “${name}”`,
  couldNotSave: (name: string) => `Could not save “${name}”`,
  couldNotRemove: (name: string) => `Could not remove “${name}”`,
  removed: (name: string) => `Removed “${name}”.`,
  couldNotBringBack: (name: string) => `Could not bring back “${name}”`,
  yourOwn: 'Your own',
  asTheSkin: 'As the skin',
  couldNotLoad: 'Your looks could not be loaded',
};
